export const allowedSpecialCharacters =
  " = + - ^ $ * . [ ] { } ( ) ? \"  ! @ # % & / \\ , > < ' : ; | _ ~ ` ";
